import i18next from '../../config/i18next';
import i18nSpecialNotice from './i18n/fr.json';
import SpecialNoticesPage from './pages/special-notices-page/special-notices-page';
import CreateSpecialNoticePage from './pages/create-special-notice-page/create-special-notice-page';
import UpdateSpecialNoticePage from './pages/update-special-notice-page/update-special-notice-page';

i18next.addResourceBundle('fr', 'special-notice', i18nSpecialNotice);

export { SpecialNoticesPage, CreateSpecialNoticePage, UpdateSpecialNoticePage };
